import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconAE({
  isAutoscallable = true,
  sizeKey = '22x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3685_63566)">
        <path
          d="M21.9915 0.0302734H0.0527344V21.9692H21.9915V0.0302734Z"
          fill="#D291FF"
        />
        <path
          d="M21.0258 0.996094H1.01758V21.0043H21.0258V0.996094Z"
          fill="#1F0040"
        />
        <path
          d="M6.22167 12.4785L5.4295 15.1786C5.41665 15.2716 5.37746 15.3028 5.29969 15.3028H3.97539C3.88456 15.3028 3.85856 15.2562 3.88456 15.1475C4.58572 12.7735 5.76719 8.81658 6.59816 6.13211C6.63696 5.97699 6.67598 5.8217 6.70197 5.27862C6.70197 5.2167 6.74099 5.18555 6.77979 5.18555H8.57159C8.6366 5.18555 8.6494 5.20114 8.67544 5.26319C9.63644 8.44412 10.6879 11.951 11.6747 15.1631C11.7007 15.2562 11.6747 15.3028 11.5968 15.3028H10.1427C10.0777 15.3028 10.0517 15.2716 10.0257 15.2096L9.19476 12.4785H6.22167ZM8.84427 10.9579C8.58465 9.91817 7.9485 7.82348 7.68879 6.73723H7.67582C7.48117 7.76144 6.94866 9.51478 6.55919 10.9579H8.84427Z"
          fill="#D291FF"
        />
        <path
          d="M13.6808 11.8941C13.7073 13.0545 14.3294 13.8793 15.6663 13.8793C16.1561 13.8793 16.7518 13.7875 17.321 13.4975C17.3607 13.4822 17.4005 13.4975 17.4005 13.5738V14.7954C17.4005 14.9023 17.3739 14.9327 17.321 14.9635C16.8047 15.2688 16.1828 15.3757 15.3354 15.3909C12.9264 15.3909 12.0527 13.4975 12.0527 11.5734C12.0527 9.38977 13.178 7.66406 15.1633 7.66406C17.1093 7.66406 17.8903 9.37439 17.8903 10.7946C17.8903 11.4511 17.824 11.7566 17.7711 11.8026C17.6123 11.8789 17.1093 11.8941 16.3813 11.8941H13.6808ZM15.7987 10.7183C16.2885 10.7183 16.368 10.6572 16.3812 10.596C16.3812 10.5657 16.3812 10.4893 16.3812 10.4281C16.3812 9.97011 16.1164 8.97745 15.0972 8.97745C14.2367 8.97745 13.7866 9.74104 13.6808 10.7183H15.7987Z"
          fill="#D291FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_3685_63566">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
